const user_scopes = {
    descriptions: {
        custom_data: 'Ваші власні дані',
        email: 'Ваша електронна пошта',
        phone: 'Ваш номер телефону',
        profile: "Ваше ім'я, ім'я користувача, аватар та інша інформація профілю",
        roles: 'Ваші ролі',
        identities: 'Ваші пов’язані соціальні ідентичності',
        'urn:logto:scope:organizations': 'Ваша інформація про організацію',
        'urn:logto:scope:organization_roles': 'Ваша роль організації',
        address: 'Ваша адреса',
        'urn:logto:scope:sessions': 'Ваші активні сесії',
        'urn:logto:scope:trusted_devices': 'Ваші довірені пристрої',
        'urn:logto:scope:personal_access_tokens': 'Ваші персональні токени доступу',
    },
};
export default Object.freeze(user_scopes);
